var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-dots"},[_c('div',{staticClass:"dot top-dot"}),_c('div',{staticClass:"dot middle-dot"}),_c('div',{staticClass:"dot bottom-dot"})])
}]

export { render, staticRenderFns }